var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('statistic-card-horizontal',{attrs:{"icon":"ClockIcon","color":"primary","statistic":new Date(_vm.dateNow).toLocaleDateString('fa-IR'),"statistic-title":_vm.formattedDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }